import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useAtom } from "jotai";
import { formDataAtom } from "../../App";
import { ONEWAY_TRIP } from "../../routes/TravelSearch";

interface RouteLink {
    Line: {
        LineName: string;
        LineTypeName: string;
        Ogt: {
            OgtTrafficTypeGroupCssClass: string;
            OgtTrafficTypeIconCssClass: string;
            OgtTrafficTypeIconReplaceLineName: boolean;
        };
    };
}
interface JourneyProps {
    journey: {
        Headline: string;
        from: string;
        to: string;
        date: string;
        travelTime: string;
        depatureArrivalTime: string;
        switches: string;
        line: RouteLink[];  
        editPath: string;
    };
    editPath: string;
    isReturnTravel: boolean;
    showEditButton?: boolean;
    showRemoveButton?: boolean;
}

export default function JourneySummary({ journey, editPath, isReturnTravel, showEditButton = true, showRemoveButton = true, }: JourneyProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const [formData, setFormData] = useAtom(formDataAtom);
    
    
    return (
        <div className="border-b border-grey-200 border-0 mb-4 pb-4 last:border-none last:mb-0 last:pb-0">
            <h3 className="summary-section-heading">{journey.Headline}</h3>
            <div className="mt-2 flex flex-col md:flex-row justify-between"> 
                <div className="flex flex-col gap-2">
                    <div>
                        <span className="summary-data-label">Från:</span>
                        <span className="summary-data">{journey.from}</span>
                    </div>
                    <div>
                        <span className="summary-data-label">Till:</span>
                        <span className="summary-data">{journey.to}</span>
                    </div>
                    <div>
                        <span className="summary-data-label">Datum för resa:</span>
                        <span className="summary-data">{journey.date}</span>
                    </div>
                    <div>
                        <span className="summary-data-label">Avgång- och ankomsttid:</span>
                        <span className="summary-data">{journey.depatureArrivalTime}</span>
                    </div>
                    <div>
                        <span className="summary-data-label">Restid:</span>
                        <span className="summary-data">{journey.travelTime}</span>
                    </div>
                    <div>
                        <span className="summary-data-label">Antal byten:</span>
                        <span className="summary-data">{journey.switches} {parseInt(journey.switches) === 1 ? "byte" : "byten"}
                        </span>
                    </div>
                    <div>
                    <div className="flex">
                        <span className="summary-data-label mb-0">Resinformation:</span>
                        <span className="lineicon-container summary-data mb-0">
                            {journey.line.length > 0 ? (
                                journey.line.map((item, index) => (
                                    <span
                                        key={index}
                                        className={`lineicon ${item?.Line?.LineTypeName || ''} ${item?.Line?.Ogt?.OgtTrafficTypeGroupCssClass || ''} ${item?.Line?.LineName?.includes('Östgötapendeln') ? 'pendeln' : ''}`}
                                    >
                                        {item?.Line?.Ogt?.OgtTrafficTypeIconReplaceLineName ? (
                                            <i
                                                className={`traffic-icon--graphic ${item?.Line?.Ogt?.OgtTrafficTypeIconCssClass || ''}-32`} 
                                                aria-hidden="true"
                                            ></i>
                                        ) : (
                                            item?.Line?.LineName || "Okänd linje"
                                        )}
                                    </span>
                                ))
                            ) : (
                                <span className="text-gray-500">Ingen linjeinformation</span>
                            )}
                        </span>

                    </div>

                    </div>
                </div>

                <div className="flex flex-col">
                    {showEditButton && (
                        <div className="summary-edit mb-4 md:mb-0 mt-3 md:mt-0">
                            <button
                                type="button"
                                className="btn stripped icon-link p-0 justify-self-end change-link pb-3 pt-3 mb-3"
                                onClick={() => navigate(journey.editPath, { state: { fromSummary: location.pathname } })}
                            >
                                <FontAwesomeIcon className="text-xl mr-2 relative text-r" icon={solid("edit")} />
                                Gå tillbaka och ändra
                            </button>
                        </div>
                    )}
                    {isReturnTravel && showRemoveButton && (
                        <div className="summary-remove">
                            <button
                                type="button"
                                className="btn stripped icon-link p-0 justify-self-end"
                                onClick={() => {
                                    setFormData({
                                        ...formData,
                                        selectedReturnJourney: {
                                            fromName: "",
                                            toName: "",
                                            date: "",
                                            travelTime: "",
                                            journeyKey: "",
                                            line: "",
                                            switches: "",
                                            unformattedDate: ""
                                        },
                                        traveltype: ONEWAY_TRIP
                                    });
                                }}
                            >
                                <FontAwesomeIcon
                                    className="text-xl mr-2 relative"
                                    icon={solid("trash-can")}
                                />
                                Ta bort
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
